module.exports = __webpack_public_path__ + "img/home-assets.a0643fe3.png";